module.exports = {
  "zones": {
    "EST5EDT": ["z", {
      "wallclock": -1.7976931348623157e+308,
      "format": "E%sT",
      "abbrev": "E%sT",
      "offset": -18000000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};